<template>
  <section class="challenge-banner" aria-labelledby="challenge-heading">
    <!-- Le défi en direct est le seul bloc en dégradé plein de l'écran : c'est ce qui le distingue
         des piliers, qui sont l'ordinaire de la page. Le classement, lui, reste sur fond clair —
         un tableau de chiffres posé sur un dégradé ne se lit plus. -->
    <div class="challenge-header">
      <h2 id="challenge-heading" class="challenge-title">
        <span aria-hidden="true">🏆</span>
        {{ challenge.title }}
      </h2>

      <p class="challenge-meta">
        Classement sur : {{ challenge.indicatorLabel }}
        <span v-if="challenge.lowerIsBetter">(le plus bas gagne)</span>
        <span v-if="challenge.endsOn">— jusqu'au {{ formattedEnd }}</span>
      </p>
    </div>

    <div class="challenge-body">
      <p v-if="ranking.length === 0" class="challenge-empty">
        Le classement s'affichera dès qu'un établissement aura marqué.
      </p>

      <!-- Un classement est un tableau de données : une liste de `div` obligerait à deviner ce que
         chaque valeur désigne. Le classement est **collectif**, il n'ordonne aucun convive (S18). -->
      <table v-else class="challenge-ranking">
        <caption class="challenge-caption">
          Classement des établissements participants
        </caption>
        <thead>
          <tr>
            <th scope="col">Rang</th>
            <th scope="col">Établissement</th>
            <th scope="col">{{ challenge.indicatorLabel }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="line in ranking" :key="line.canteen">
            <td>{{ line.rank }}</td>
            <td>{{ line.canteenName }}</td>
            <td>{{ line.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
/**
 * Bandeau du défi en cours de l'établissement.
 *
 * Il était intégralement écrit : « Battle Resto EN DIRECT ! », deux collèges inventés, un compte à
 * rebours figé et un bouton d'appel à l'action qui ne menait nulle part. Il pulsait en outre par
 * une animation infinie, ce qu'aucune préférence de mouvement réduit ne pouvait arrêter — d'où
 * l'absence d'animation ici (§9.2.4).
 */
export default {
  name: "LiveChallengeBanner",

  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ranking() {
      return this.challenge.ranking || []
    },

    formattedEnd() {
      if (!this.challenge.endsOn) return ""
      return new Date(this.challenge.endsOn).toLocaleDateString("fr-FR")
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../scss/nutriquest";

.challenge-banner {
  @include nq-card;
  overflow: hidden;
  padding: 0;
}

/* Les teintes de la maquette sont reprises un cran plus sombre : sur les siennes, le texte blanc
   ne tenait pas le 4,5:1 du RGAA. */
.challenge-header {
  background: $nq-live-gradient;
  color: #ffffff;
  padding: 1.25rem;
}

.challenge-body {
  padding: 1.25rem;
}

.challenge-title {
  color: inherit;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.challenge-meta {
  color: inherit;
  font-size: 0.875rem;
  margin: 0;
}

.challenge-empty {
  color: $nq-ink-soft;
  font-style: italic;
  margin: 0;
}

.challenge-ranking {
  border-collapse: collapse;
  width: 100%;
}

.challenge-caption {
  color: $nq-ink-soft;
  font-size: 0.8125rem;
  padding-bottom: 0.5rem;
  text-align: left;
}

.challenge-ranking th,
.challenge-ranking td {
  border-bottom: 1px solid $nq-border;
  padding: 0.5rem 0.25rem;
  text-align: left;
}

.challenge-ranking th {
  color: $nq-ink-soft;
  font-size: 0.8125rem;
}
</style>
